<template>
    <div class="column is-full">
        <div class="card-content">
            <h2 class="has-text-centered has-text-weight-semibold is-size-4">{{sectionName}}</h2>
            <p v-for="dataPoint in order.customData" :key="dataPoint.id">
                <strong>{{dataPoint.customFieldObj.title}}: </strong>
                <span v-if="dataPoint.customFieldObj.fieldType == 'select'">{{dataPoint.customFieldOptionObj.title}}</span>
                <span v-else>{{dataPoint.title}}</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        order:{
            type:Object,
            default: new Object({})
        },
        sectionName:{
            type:String,
            default:""
        }
    }
}
</script>